export abstract class CirclesError extends Error {}
